import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/user/accounts/createUserContainer';
import { actions } from '../../../redux/user/accounts';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
